"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tradingDisabledSelector = exports.noBalanceSelector = exports.marketPriceOfSelectedInstrumentSelector = exports.marketPriceOfSelectedFuturesInstrumentSelector = exports.isBuySideBuySellFormSelector = exports.getQuantityDataForPresetValuesSelector = exports.getQuantityDataForPresetAndCustomValuesSelector = exports.getPriceDataForQuantitiesSelector = exports.getPriceDataForPricesSelector = exports.getPriceDataForPresetValuesSelector = exports.getPriceDataForPresetAndCustomValuesSelector = exports.getOrderFormInfoSelector = void 0;
var _reselect = require("reselect");
var _reduxForm = require("redux-form");
var _numberFormatter = require("../../helpers/numberFormatter");
var _orderHelper = require("../../helpers/orderHelper");
var _productHelper = require("../../helpers/productHelper");
var _instrumentPositionSelectors = require("../selectors/instrumentPositionSelectors");
var _kycLevelsSelectors = require("../selectors/kycLevelsSelectors");
var _BuySellLayoutTypes = require("../../components/Retail/RetailBuySell/BuySell/BuySellLayoutTypes");
var _orderEntryFormConstants = require("../../constants/sendOrder/orderEntryFormConstants");
var _config = _interopRequireDefault(require("../../config"));
var _productPositionSelectors = require("./productPositionSelectors");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _selectors = require("../futures/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var marketPriceOfSelectedInstrumentSelector = exports.marketPriceOfSelectedInstrumentSelector = (0, _reselect.createSelector)([_instrumentPositionSelectors.selectedInstrumentSelector, function (state) {
  return state.apexCore.level1;
}, function (state, options) {
  return options;
}], function (instrument, level1, options) {
  var side = options.side,
    formatToLocale = options.formatToLocale,
    decimalPlaces = options.decimalPlaces;
  var formatToLocaleOption = formatToLocale === undefined || formatToLocale;
  var l1 = instrument ? level1[instrument.InstrumentId] : null;
  var marketPrice = (0, _orderHelper.getMarketPrice)(side, instrument, l1, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement));
  if (instrument && formatToLocaleOption) {
    return (0, _numberFormatter.formatNumberToLocale)(marketPrice, !decimalPlaces ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement) : decimalPlaces);
  }
  return marketPrice;
});
var marketPriceOfSelectedFuturesInstrumentSelector = exports.marketPriceOfSelectedFuturesInstrumentSelector = (0, _reselect.createSelector)([_selectors.futuresSelectedInstrumentSelector, _selectors.futuresLevel1Selector, function (state, options) {
  return options;
}], function (instrument, level1, options) {
  var side = options.side,
    formatToLocale = options.formatToLocale,
    decimalPlaces = options.decimalPlaces;
  var formatToLocaleOption = formatToLocale === undefined || formatToLocale;
  var l1 = instrument ? level1[instrument.InstrumentId] : null;
  var marketPrice = (0, _orderHelper.getMarketPrice)(side, instrument, l1, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument === null || instrument === void 0 ? void 0 : instrument.PriceIncrement));
  if (instrument && formatToLocaleOption) {
    return (0, _numberFormatter.formatNumberToLocale)(marketPrice, !decimalPlaces ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument === null || instrument === void 0 ? void 0 : instrument.PriceIncrement) : decimalPlaces);
  }
  return marketPrice;
});
var isBuySideBuySellFormSelector = exports.isBuySideBuySellFormSelector = (0, _reselect.createSelector)([function (state) {
  return state.form.buySell;
}], function (formObj) {
  return formObj ? formObj.values.side === _orderEntryFormConstants.buyValue : true;
});

/**
 * accept array of prices values and return price, quantity, limitPrice and pricePerUnit for them
 */
var getPriceDataForPricesSelector = exports.getPriceDataForPricesSelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.level2;
}, function (state, side) {
  return side;
}, function (state, side, prices) {
  return prices;
}, _instrumentPositionSelectors.selectedInstrumentSelector], function (level2, side, prices, selectedInstrument) {
  var _config$OrderCalcBuff = _config["default"].OrderCalcBuffer,
    _config$OrderCalcBuff2 = _config$OrderCalcBuff === void 0 ? {} : _config$OrderCalcBuff,
    quantityBuffer = _config$OrderCalcBuff2.quantityBuffer;
  var orders = (0, _orderHelper.getOrdersBySide)(side, level2);
  return prices.map(function (price) {
    var _getQuantityForPrice = (0, _orderHelper.getQuantityForPrice)(price, quantityBuffer, orders, true, side),
      Quantity = _getQuantityForPrice.Quantity,
      LimitPrice = _getQuantityForPrice.LimitPrice;
    var quantity = (0, _numberFormatter.truncateToDecimals)(Quantity, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement)).toNumber();
    var pricePerUnit = quantity > 0 ? (0, _numberFormatter.truncateToDecimals)(price / quantity, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement)).toNumber() : null;
    return {
      price: price,
      quantity: quantity,
      limitPrice: (0, _numberFormatter.truncateToDecimals)(LimitPrice, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement)).toNumber(),
      pricePerUnit: pricePerUnit
    };
  });
});

/**
 * return array of object of format {price, quantity, limitPrice and pricePerUnit} for preset values
 */
var getPriceDataForPresetValuesSelector = exports.getPriceDataForPresetValuesSelector = (0, _reselect.createSelector)([function (state) {
  return state;
}, function (state, buySell) {
  return buySell;
}, _instrumentPositionSelectors.selectedInstrumentSelector], function (state, side, selectedInstrument) {
  var dealPrices = _config["default"].RetailBuySell.dealPrices;
  var prices = dealPrices[selectedInstrument.Symbol];
  if (!prices) {
    prices = dealPrices['DEFAULT'];
  }
  return getPriceDataForPricesSelector(state, side, prices);
});

/**
 * return array of object of format {price, quantity, limitPrice and pricePerUnit}
 * for preset values and custom row
 */
var getPriceDataForPresetAndCustomValuesSelector = exports.getPriceDataForPresetAndCustomValuesSelector = (0, _reselect.createSelector)([function (state) {
  return state;
}, function (state, buySell) {
  return buySell;
}, function (state, buySell, customPrice) {
  return customPrice;
}, _instrumentPositionSelectors.selectedInstrumentSelector], function (state, side, customPrice, selectedInstrument) {
  var dealPrices = _config["default"].RetailBuySell.dealPrices;
  var prices = dealPrices[selectedInstrument.Symbol];
  if (!prices) {
    prices = dealPrices['DEFAULT'];
  }
  var totalPrices = [customPrice].concat(prices);
  return getPriceDataForPricesSelector(state, side, totalPrices);
});

/**
 * accept array of quantity values and return quantity, price, limitPrice and pricePerUnit for them
 */
var getPriceDataForQuantitiesSelector = exports.getPriceDataForQuantitiesSelector = (0, _reselect.createSelector)([function (state) {
  return state.apexCore.level2;
}, function (state, side) {
  return side;
}, function (state, side, quantities) {
  return quantities;
}, _instrumentPositionSelectors.selectedInstrumentSelector], function (level2, side, quantities, selectedInstrument) {
  var _config$OrderCalcBuff3 = _config["default"].OrderCalcBuffer,
    _config$OrderCalcBuff4 = _config$OrderCalcBuff3 === void 0 ? {} : _config$OrderCalcBuff3,
    priceBuffer = _config$OrderCalcBuff4.priceBuffer;
  var orders = (0, _orderHelper.getOrdersBySide)(side, level2);
  return quantities.map(function (quantity) {
    var _getPriceForQuantity = (0, _orderHelper.getPriceForQuantity)(quantity, priceBuffer, orders, false, side),
      Price = _getPriceForQuantity.Price,
      LimitPrice = _getPriceForQuantity.LimitPrice;
    var price = (0, _numberFormatter.truncateToDecimals)(Price, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement)).toNumber();
    var pricePerUnit = price / quantity;
    pricePerUnit = quantity > 0 && pricePerUnit ? (0, _numberFormatter.formatNumberToLocale)(pricePerUnit, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement)).toString() : null;
    return {
      price: price,
      quantity: quantity,
      limitPrice: (0, _numberFormatter.truncateToDecimals)(LimitPrice, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement)).toNumber(),
      pricePerUnit: pricePerUnit
    };
  });
});

/**
 * return array of object of format {quantity, price, limitPrice and pricePerUnit} for preset values
 */
var getQuantityDataForPresetValuesSelector = exports.getQuantityDataForPresetValuesSelector = (0, _reselect.createSelector)([function (state) {
  return state;
}, function (state, buySell) {
  return buySell;
}, _instrumentPositionSelectors.selectedInstrumentSelector], function (state, side, selectedInstrument) {
  var dealQuantities = _config["default"].RetailBuySell.dealPrices;
  var quantities = dealQuantities[selectedInstrument.Symbol];
  if (!quantities) {
    return [];
  }
  return getPriceDataForQuantitiesSelector(state, side, quantities);
});

/**
 * return array of object of format {quantity, price, limitPrice and pricePerUnit}
 * for preset values and custom row
 */
var getQuantityDataForPresetAndCustomValuesSelector = exports.getQuantityDataForPresetAndCustomValuesSelector = (0, _reselect.createSelector)([function (state) {
  return state;
}, function (state, buySell) {
  return buySell;
}, function (state, buySell, customQuantity) {
  return customQuantity;
}, _instrumentPositionSelectors.selectedInstrumentSelector], function (state, side, customQuantity, selectedInstrument) {
  var dealQuantities = _config["default"].RetailBuySell.dealPrices;
  var quantities = dealQuantities[selectedInstrument.Symbol];
  if (!quantities) {
    return [];
  }
  var totalQuantities = [customQuantity].concat(quantities);
  return getPriceDataForQuantitiesSelector(state, side, totalQuantities);
});

// responsible to return price, quantity, limitPrice, pricePerUnit
// from current state of buySell form depending on layoutType,
// what is selected (custom radio section or initally set values)
var getOrderFormInfoSelector = exports.getOrderFormInfoSelector = (0, _reselect.createSelector)([function (state) {
  return state;
}, function (state) {
  return state.form.buySell || {
    values: {}
  };
}], function (state, form) {
  var _form$values = form.values,
    side = _form$values.side,
    amountRadio = _form$values.amountRadio;
  var isPricePerUnitLayoutType = form.values.layoutType === _BuySellLayoutTypes.BUY_SELL_LAYOUTS.PRICE_PER_UNIT;
  var fieldToSearch = isPricePerUnitLayoutType ? 'quantity' : 'price';
  var value = amountRadio === 'custom' ? form.values[fieldToSearch] : amountRadio;
  var dealValues = isPricePerUnitLayoutType ? getQuantityDataForPresetAndCustomValuesSelector(state, side, value) : getPriceDataForPresetAndCustomValuesSelector(state, side, value);
  return (0, _orderHelper.getValuesFromDealValues)(dealValues, value, fieldToSearch);
});
var tradingDisabledSelector = exports.tradingDisabledSelector = (0, _reselect.createSelector)([function (state) {
  return state;
}], function (state) {
  return (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state).disableTrading;
});
var noBalanceSelector = exports.noBalanceSelector = (0, _reselect.createSelector)([function (state) {
  return state;
}, function (state) {
  return isBuySideBuySellFormSelector(state);
}, function (state) {
  return state.form.buySell || {
    values: {}
  };
}], function (state, isBuySide, form) {
  var selector = (0, _reduxForm.formValueSelector)('buySell');
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var product1 = (0, _productPositionSelectors.getProductByIdSelector)(state, selectedInstrument.Product1);
  var product2 = (0, _productPositionSelectors.getProductByIdSelector)(state, selectedInstrument.Product2);
  var selectedValue = getOrderFormInfoSelector(state);
  var activeAmount = selector(state, 'amountRadio');
  var price = activeAmount === 'custom' ? form.values.price : +activeAmount;
  var quantity = selectedValue.quantity;
  var negativeIsNaN = false;
  return isBuySide ? (0, _productHelper.getAvailableProductBalance)(product2, negativeIsNaN) < price : (0, _productHelper.getAvailableProductBalance)(product1, negativeIsNaN) < quantity;
});